// Pop-up windows with jquery (http://www.djsipe.com/2008/07/04/doing-pop-ups-the-right-way-with-jquery/)
// Create a namespace for our utilities
window["UTIL"] = window.UTIL || {};
window.UTIL.popup = window.UTIL.popup || {};

const MOD_ACTION_SUSPEND_TIMED = 'suspend';

window["clearAllNextSelect"] = function (cur_select) {
    return cur_select.nextAll("select")
        .each(function () {
            $(this).html('<option value=""></option>').hide();
        })
        .first();
}

// Reveal/hide conditional form blocks (device-ban opt-in, final-warning)
// based on the current top-level action. Call after any programmatic
// change to todo[0] since jQuery's .val() doesn't fire a change event.
window["syncModConditionalBlocks"] = function ($form) {
    const $top = $form.find("select[name='todo[0]']");
    if (!$top.length) return;
    const topVal = String($top.val() || '');
    const suspendSelected = topVal === MOD_ACTION_SUSPEND_TIMED;
    const $suspendPanel = $form.siblings('.modSuspendActionPanel');
    $suspendPanel.toggleClass('hidden', !suspendSelected);
    $form.find('.modLegacyActionControls').toggleClass('hidden', suspendSelected);
    const $pdb = $form.find('.propagateDeviceBan');
    if (topVal === '2') {
        $pdb.removeClass('hidden');
    } else {
        $pdb.addClass('hidden');
        $pdb.find('input[name="propagate_device_ban"]').prop('checked', false);
    }
    // Resync downstream state (Additional-actions wrapper, photo-ban row,
    // submit-button gate) so the wrapper hides cleanly when this call just
    // hid the only visible row inside it.
    if (typeof window.syncModSubmitState === 'function') {
        window.syncModSubmitState($form);
    }
};

// A preset click supersedes any earlier one still in flight on the same form.
// Each level is fetched by its own request, so without this the responses of an
// abandoned preset can land after a later preset has already rewritten the
// form and reassemble their own chain across the selects. Returns a predicate
// the async callbacks check before touching the DOM.
window["claimModPresetGeneration"] = function ($form) {
    // With no form element there is nowhere to record the generation, and a
    // stamp written to an empty set reads back as undefined — which would mark
    // every response stale and leave the preset doing nothing at all.
    if (!$form.length) {
        return function () {
            return false;
        };
    }

    const seq = ($form.data('modPresetSeq') || 0) + 1;
    $form.data('modPresetSeq', seq);

    return function () {
        return $form.data('modPresetSeq') !== seq;
    };
};

// A preset that fills every level leaves no select awaiting a choice, so park
// focus on the log message: that is where Ctrl+Enter is bound, and it is what
// the card's "number keys, Ctrl+Enter to submit" tip assumes. Deferred, so it
// yields to a moderator who has already moved focus somewhere deliberate
// rather than pulling them out of another card mid-typing.
window["focusModPresetLogMessage"] = function ($form, originEl) {
    const active = document.activeElement;

    if (active && active !== document.body && active !== originEl) {
        return;
    }

    $form.find("textarea[name='log_msg'], .logMsgTA").first().focus();
};

window["modShortcut"] = function (button, cat_arr, show_child_select) {
    const num_selects = show_child_select ? cat_arr.length + 1 : cat_arr.length;

    const $form = button.closest('.modActions').find("form").first();
    const isStale = window.claimModPresetGeneration($form);

    // Firefox and Safari leave focus untouched when a button is clicked, where
    // Chromium moves it onto the button. Claiming it here gives the deferred
    // reveal below one meaning of "the moderator has not moved on" in every
    // browser, instead of stranding keyboard focus on the last card typed in.
    button.trigger('focus');

    for (var i = 0; i < num_selects; i++) {
        // The selects are addressed through the card wrapper while the
        // generation is recorded on the form, so a second form under the same
        // wrapper carrying todo[] selects would leave those selects untracked.
        const sel = button.closest('.modActions').find("select[name^='todo\[" + i + "\]']"),
            cat_slice_end = i < cat_arr.length ? i : cat_arr.length,
            selected = i < cat_arr.length ? cat_arr[i] : undefined;

        if (!sel.length) break;
        modPopulateSelect(sel, cat_arr.slice(0, cat_slice_end), selected, isStale);
        sel.show();

        if (i === 0) clearAllNextSelect(sel);
    }

    // Top-level val is assigned inside modPopulateSelect's async JSON
    // callback, so defer the reveal until after that round-trip.
    setTimeout(function () {
        // Derived wholly from the live DOM, so it is correct to run even once a
        // later preset or a manual pick owns the form. Skipping it here would
        // strand the device-ban opt-in hidden under a Delete, because the
        // change handler only re-syncs when todo[0] itself changed.
        window.syncModConditionalBlocks($form);

        if (isStale()) return;

        if (!show_child_select) {
            window.focusModPresetLogMessage($form, button[0]);
        }
    }, 300);
}

// Like modShortcut, but scoped to a specific form root instead of the legacy
// `.modActions` wrapper — used by the moderate-user modal to pre-fill
// category cascades after AJAX content loads. Every preset reachable here stops
// on a non-leaf, so unlike modShortcut it has no completed chain to route focus
// off of; a preset added to applyModPreset that ends on a leaf needs that.
window["modShortcutInForm"] = function ($form, cat_arr, show_child_select) {
    const num_selects = show_child_select ? cat_arr.length + 1 : cat_arr.length;
    const isStale = window.claimModPresetGeneration($form);

    for (var i = 0; i < num_selects; i++) {
        const sel = $form.find("select[name^='todo\[" + i + "\]']"),
            cat_slice_end = i < cat_arr.length ? i : cat_arr.length,
            selected = i < cat_arr.length ? cat_arr[i] : undefined;

        if (!sel.length) break;
        modPopulateSelect(sel, cat_arr.slice(0, cat_slice_end), selected, isStale);
        sel.show();

        if (i === 0) clearAllNextSelect(sel);
    }

    // Same reasoning as modShortcut: the reveal reads the live DOM, so a later
    // owner of the form does not make it wrong to run.
    setTimeout(function () {
        window.syncModConditionalBlocks($form);
    }, 300);
};

// Apply a named preset (category pre-selection + log message) to the
// moderation form inside the given root element.
window["applyModPreset"] = function (root, preset) {
    const PRESETS = {
        scam: { cats: [2, 27, 47], showChild: true, logMsg: 'flagged: mmip scam' },
    };
    const cfg = PRESETS[preset];
    if (!cfg) return;

    const rootEl = root instanceof Element ? root : (root && root.$el) || document;
    const $form = $(rootEl).find('form.reportForm, form.asyncReportForm').first();
    if (!$form.length) return;

    window.modShortcutInForm($form, cfg.cats, cfg.showChild);
    if (cfg.logMsg) {
        $form.find("textarea[name='log_msg'], .logMsgTA").val(cfg.logMsg);
    }
};

// Focus the next report action select when the report card uses the desktop layout.
window["focusNextRep"] = function (cur_rep) {
    if (window.matchMedia && !window.matchMedia("(min-width: 768px)").matches) {
        return;
    }

    let next_rep;
    if (cur_rep === undefined) {
        next_rep = $("div.userReport:visible").first();
    } else {
        next_rep = cur_rep.nextAll(".userReport:visible").first();
    }

    if (next_rep.length > 0) {
        const $select = next_rep.find(".mod_actions_sel").first();
        if ($select.length > 0) {
            // Small delay to ensure DOM is ready
            setTimeout(function() {
                $select.focus();
            }, 100);
        }
    }
};

window["modPopulateSelect"] = function (select_elem, levels, selectedIdx, isStale) {
    let cur_values = {};
    $.each(levels, function (i, v) {
        cur_values["levels[" + i + "]"] = v;
    });
    // Get new option set
    $.getJSON("/app/mod/report-queue/options", cur_values, function (j) {
        // A response belonging to a superseded preset must not write into a
        // form the moderator has since pointed at a different action.
        if (typeof isStale === 'function' && isStale()) {
            return;
        }
        if (j !== null && !$.isEmptyObject(j)) {
            var options = '';
            var i = 0;
            $.each(j, function (val, name) {
                options += '<option value="' + val + '">' + i + ': ' + name + '</option>';
                i++;
            });
            select_elem.html(options).show();
            if (selectedIdx !== undefined) {
                select_elem.val(selectedIdx);
                select_elem.attr("size", 1);
            } else {
                select_elem.attr("size", i);
                select_elem.val('');
                // Only a select still awaiting a choice takes focus. A select
                // a preset already filled has nothing to pick, and focusing it
                // routes number keys into the browser's native option
                // type-ahead, which swaps the chosen category for a sibling.
                select_elem.focus();
            }
            if (typeof window.syncModSubmitState === 'function') {
                window.syncModSubmitState(select_elem.closest('form'));
            }
        } else {
            select_elem.html('<option value=""></option>').hide();
        }
    });
}

//
// Open popup window
//
// Opens a popup window using as little as a URL. An optional params object can
// be passed.
//
// @param {String} href
// @param {Object} params
// @return {WindowObjectReference}
//
UTIL.popup.open = function (href, params) {
    // Defaults (don't leave it to the browser)
    var defaultParams = {
        "width": "600",   // Window width
        "height": "420",   // Window height
        "top": "0",     // Y offset (in pixels) from top of screen
        "left": "0",     // X offset (in pixels) from left side of screen
        "directories": "no",    // Show directories/Links bar?
        "location": "no",    // Show location/address bar?
        "resizeable": "yes",   // Make the window resizable?
        "menubar": "no",    // Show the menu bar?
        "toolbar": "no",    // Show the tool (Back button etc.) bar?
        "scrollbars": "yes",   // Show scrollbars?
        "status": "no"     // Show the status bar?
    };

    var windowName = params["windowName"] || "new_window";

    var i, useParams = "";

    // Override defaults with custom values while we construct the params string
    for (i in defaultParams) {
        useParams += (useParams === "") ? "" : ",";
        useParams += i + "=";
        useParams += params[i] || defaultParams[i];
    }

    return window.open(href, windowName, useParams);
};


$(function () {
    var cats_novio = [3, 14];
    var cats_scams = [2, 27, 47];
    var cats_sex = [2, 27, 48];
    var cats_fake = [2, 29, 96];

    // Quick "Undo delete" shortcut on mod-log entry rows. Rows are rendered by
    // mod/partials/log-entry.twig and appear on /app/mod/log, in the
    // moderate-user modal log column, and inside reports-queue card previews,
    // so a delegated global handler keeps all surfaces in sync without each
    // template re-inlining the same script. Rows that opt out via
    // data-return-to (e.g. text-filter deletions) are handled by their own
    // page-scoped script and skip the default.
    document.addEventListener('click', function (e) {
        var link = e.target.closest('.mod-log-undo-delete');
        if (!link || link.dataset.returnTo) {
            return;
        }
        e.preventDefault();

        var defaultLogMsg = 'Reinstated via quick action.';
        var logMsg = (typeof window.trans === 'function')
            ? window.trans('common', 'mod_log_undo_delete_log_msg')
            : defaultLogMsg;

        var params = new URLSearchParams({
            user_id: link.dataset.userId,
            todo: 'reinstate_prompt',
            return_to: 'log',
            log_msg: logMsg
        });
        window.location.href = '/app/mod/reinstate?' + params.toString();
    });


    // Keyboard shortcuts for moderation actions (0-5 keys)
    $(document).on('keydown', function(e) {
        // Only handle number keys 0-5 when not in an input field
        if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA' || e.target.tagName === 'SELECT') {
            return;
        }

        // Don't interfere with browser shortcuts (Cmd/Ctrl/Alt+key combinations)
        if (e.metaKey || e.ctrlKey || e.altKey || e.shiftKey) {
            return;
        }

        const key = e.key;
        if (key >= '0' && key <= '5') {
            e.preventDefault();
            
            // Find the currently visible report's action select
            const $visibleReport = $("div.userReport:visible").first();
            if ($visibleReport.length === 0) return;
            
            const $actionSelect = $visibleReport.find(".mod_actions_sel:visible").first();
            if ($actionSelect.length === 0) return;
            
            // Focus the select if not already focused
            if (!$actionSelect.is(':focus')) {
                $actionSelect.focus();
            }
            
            // Select the option by index
            const optionIndex = parseInt(key);
            const $options = $actionSelect.find('option');
            if (optionIndex < $options.length) {
                $actionSelect.val($options.eq(optionIndex).val());
                $actionSelect.trigger('change');
                
                // After selecting, check if this was the last select and focus log message
                setTimeout(function() {
                    const $nextVisibleSelect = $visibleReport.find(".mod_actions_sel:visible");
                    const $lastVisibleSelect = $nextVisibleSelect.last();
                    
                    // If the current select is the last visible one, focus the log message
                    if ($actionSelect.is($lastVisibleSelect)) {
                        const $logMsg = $visibleReport.find("textarea[name='log_msg'], .logMsgTA").first();
                        if ($logMsg.length > 0) {
                            $logMsg.focus();
                        }
                    }
                }, 150);
            }
        }
    });

    // Report page shortcuts
    $(".modact_novio").click(function () {
        modShortcut($(this), cats_novio);
    });

    $(".modact_scams").click(function () {
        modShortcut($(this), cats_scams, true);
    });
    $(".modact_sex").click(function () {
        modShortcut($(this), cats_sex, true);
    });
    // "Other Fake" (96) is a leaf under Profile Content Violation, so no
    // child select follows it.
    $(".modact_fake").click(function () {
        modShortcut($(this), cats_fake);
    });


    $(".archive").click(function () {
        $(this).parents("form").find("input[name='todo']").val("archive");
    });
    $(".del_reports").click(function () {
        $(this).parents("form").find("input[name='todo']").val("del_reports");
    });
    $(".delete").click(function () {
        $(this).parents("form").find("input[name='todo']").val("delete");
    });
    $(".delScam").click(function () {
        $(this).parents("form").find("input[name='todo']").val("delete");
        $(this).parents("form").find("textarea[name='log_msg']").val("fast:scam");
    });
    $(".logMsgSubmit").click(function () {
        $(this).parents("form").find("input[name='todo']").val("log_msg");
    });
    $(".del_photo").click(function (e) {
        $(this).parents("form").find("input[name='todo']").val("delete_photo");
        $(this).parents("form").find("input[name='pid']").val($(this).attr('pid'));
        $(this).parents("form").submit();
        e.preventDefault();
    });
    $(".appr_photo").click(function (e) {
        $(this).parents("form").find("input[name='todo']").val("approve_photo");
        $(this).parents("form").find("input[name='pid']").val($(this).attr('pid'));
        $(this).parents("form").submit();
        e.preventDefault();
    });
    $(".reset_changes").click(function (e) {
        if (confirm($(this).attr('conf'))) {
            $(this).parents("form").find("input[name='todo']").val($(this).attr('name'));
            $(this).parents("form").submit();
        }
        e.preventDefault();
    });
    $(".show_del_options").click(function (e) {
        $(".modActDel").toggle();
        e.preventDefault();
    });
    $(".show_reset_options").click(function (e) {
        $(".modActReset").toggle();
        e.preventDefault();
    });

//  // "Clear all reports by this reporter"
//  $(".del_reports_by_user").click(function(e) {
//    $(this).parents("form").find("input[name='todo']'").val("del_reports_by_user");
//    $(this).parents("form").find("input[name='rep_uid']'").val($(this).attr('rep_uid'));
//    $(this).parents("form").submit();
//    e.preventDefault();
//  });
//
    // Mirror of ModHelper::MOD_ACTION_CAT_ID_DELETE — the cat_0 id used for
    // the "Delete account" action. Re-checked server-side in
    // ModerationActionDispatcher; the value is also baked into mod category
    // metadata, so it should never change. There is no automated sync between
    // the PHP constant and this literal — if the PHP id is ever renumbered,
    // update this value and the data-attribute checks in _mod-actions-form.twig
    // by hand, then exercise the longtime-account ack flow in the modal.
    var MOD_ACTION_CAT_ID_DELETE = 2;

    // Build the JSON payload mirroring the legacy form-POST shape, then send
    // it through the JWT endpoint so `ban_photos_opt_in` and the optional
    // note travel alongside the existing delete payload. Only invoked when
    // the moderator opts in via the photo-ban checkbox (other actions stay on
    // /app/mod/action).
    function submitModDeleteViaApi($form, $logMsgField) {
        if (!window.ApiClient) {
            $logMsgField.removeClass('ajx_load');
            window.alert('Cannot reach the moderation API. Please refresh the page.');
            return;
        }
        var uid = String($form.find("input[name='uid']").val() || '');
        if (uid === '') {
            $logMsgField.removeClass('ajx_load');
            window.alert('Cannot identify the moderation target user.');
            return;
        }

        var payload = {};
        $.each($form.serializeArray(), function (_, entry) {
            var name = entry.name;
            var value = entry.value;
            if (/^todo\[\d+\]$/.test(name)) {
                payload.todo = payload.todo || [];
                payload.todo.push(value);
                return;
            }
            payload[name] = value;
        });
        payload.ban_photos_opt_in = $form.find("input[name='ban_photos_opt_in']").is(':checked') ? '1' : '0';
        var noteVal = ($form.find("textarea[name='ban_photos_opt_in_note']").val() || '').trim();
        if (noteVal !== '') {
            payload.ban_photos_opt_in_note = noteVal;
        }

        window.ApiClient.request('/mod/users/' + encodeURIComponent(uid) + '/delete', {
            method: 'POST',
            body: JSON.stringify(payload)
        }).then(function (res) {
            // ApiClient may return a Response or a parsed object depending on
            // version. Normalise to an object before branching so a future
            // ApiClient revision can't silently change the success path.
            if (res && typeof res.json === 'function') {
                return res.json().then(function (body) { return { ok: res.ok, body: body }; });
            }
            return { ok: true, body: res };
        }).then(function (envelope) {
            $logMsgField.removeClass('ajx_load');
            if (!envelope.ok) {
                // The /v1 error envelope nests {code, message} under "error".
                // Fall back to a plain-string error key and a generic message.
                var err = envelope.body && envelope.body.error;
                var msg = (err && typeof err === 'object' && err.message)
                    ? err.message
                    : (typeof err === 'string' && err ? err : 'Moderation request failed.');
                window.alert(msg);
                return;
            }
            // Reload the parent if we're nested in the moderator modal/iframe,
            // matching the legacy success behavior.
            if (window.top !== window.self) {
                window.top.location.reload(true);
            } else {
                window.location.reload(true);
            }
        }).catch(function (err) {
            $logMsgField.removeClass('ajx_load');
            window.alert((err && err.message) ? err.message : 'Network error.');
        });
    }

    // Show/hide the longtime-account ack block based on the selected top-level
    // action. The block only matters when the action is Delete and the form
    // was rendered with data-tenure-requires-ack="1".
    function syncLongtimeAckVisibility($form, topVal) {
        var $ack = $form.find(".longtimeAck");
        if ($ack.length === 0) return;
        var requiresAck = $form.attr('data-tenure-requires-ack') === '1';
        var isDelete = String(topVal) === String(MOD_ACTION_CAT_ID_DELETE);
        var show = requiresAck && isDelete;
        $ack.toggleClass('hidden', !show);
        if (!show) {
            $ack.find("input[name='account_age_ack']").prop('checked', false);
        }
    }

    // Show/hide the photo-ban opt-in row. Visible whenever the moderator is
    // deleting a single user — the scam-flow delete (Delete → Message Violation
    // → Scam) is the most common path where blacklisting the avatar matters,
    // so don't narrow visibility to Photo Violation only. Clearing the
    // checkbox + note when hidden prevents a stale tick from riding along
    // after the moderator switches off Delete.
    function syncBanPhotosOptInVisibility($form, topVal) {
        var $row = $form.find(".banPhotosOptIn");
        if ($row.length === 0) return;
        var show = String(topVal) === String(MOD_ACTION_CAT_ID_DELETE);
        $row.toggleClass('hidden', !show);
        if (!show) {
            $row.find("input[name='ban_photos_opt_in']").prop('checked', false);
            $form.find("textarea[name='ban_photos_opt_in_note']").val('');
            $form.find(".banPhotosOptInNoteWrap").addClass('hidden');
        }
    }

    // Show the "Additional actions" wrapper only when at least one row inside
    // is currently visible. Keeps the header from sitting empty when the
    // moderator picks a non-Delete action or a Delete sub-action that doesn't
    // qualify for either opt-in.
    function syncAdditionalActionsVisibility($form) {
        var $wrap = $form.find(".additionalActions");
        if ($wrap.length === 0) return;
        var anyVisible = $wrap.find(".propagateDeviceBan, .banPhotosOptIn")
            .filter(function () { return !$(this).hasClass('hidden'); })
            .length > 0;
        $wrap.toggleClass('hidden', !anyVisible);
    }

    // Keep the submit button hidden until a top-level action (todo[0]) is
    // chosen. The first select renders as a multi-row list with no default
    // selection, so without this guard the browser would happily post an
    // empty value.
    //
    // Longtime-account ack and log-message requirements are validated at
    // submit time by validateModDeleteGating, which reveals inline errors
    // next to the offending field. Server-side enforcement in
    // ModerationActionDispatcher is authoritative.
    window.syncModSubmitState = function ($form) {
        var $btn = $form.find(".modActionSubmit");
        if ($btn.length === 0) return;
        var $top = $form.find("select[name='todo[0]']").first();
        var val = $top.val();
        var hasAction = val !== null && val !== undefined && val !== '';
        var suspendSelected = String(val) === MOD_ACTION_SUSPEND_TIMED;

        syncLongtimeAckVisibility($form, val);
        syncBanPhotosOptInVisibility($form, val);
        syncAdditionalActionsVisibility($form);

        $form.siblings('.modSuspendActionPanel').toggleClass('hidden', !suspendSelected);
        $form.find('.modLegacyActionControls').toggleClass('hidden', suspendSelected);

        $btn.prop('disabled', !hasAction || suspendSelected).toggleClass('hidden', !hasAction || suspendSelected);

        if (suspendSelected) {
            $form.find(".longtimeAckError, .logMsgError").addClass('hidden');
            return;
        }

        // Clear inline errors when the gating no longer applies (action is
        // not Delete, or the form was never tenure-gated). The submit
        // handler reveals them again if a later submit still has gaps.
        var deleteSelected = hasAction && String(val) === String(MOD_ACTION_CAT_ID_DELETE);
        var gated = deleteSelected && $form.attr('data-tenure-requires-ack') === '1';
        if (!gated) {
            $form.find(".longtimeAckError, .logMsgError").addClass('hidden');
            return;
        }

        // Within the gated state, also clear each error as the moderator
        // addresses the corresponding field.
        if ($form.find("input[name='account_age_ack']").is(':checked')) {
            $form.find(".longtimeAckError").addClass('hidden');
        }
        var logMsg = ($form.find("textarea[name='log_msg']").val() || '').trim();
        if (logMsg !== '') {
            $form.find(".logMsgError").addClass('hidden');
        }
    };

    // Validate the longtime-account gating on submit. Returns true if the
    // form may be submitted; false if a required field is missing, in which
    // case inline error nodes are revealed and focus is moved to the first
    // offender. Only runs for Delete actions on forms rendered with
    // data-tenure-requires-ack="1".
    function validateModDeleteGating($form) {
        var $top = $form.find("select[name='todo[0]']").first();
        var val = $top.val();
        if (String(val) !== String(MOD_ACTION_CAT_ID_DELETE)) return true;
        if ($form.attr('data-tenure-requires-ack') !== '1') return true;

        var $ackErr = $form.find(".longtimeAckError");
        var $logErr = $form.find(".logMsgError");
        var $ack = $form.find("input[name='account_age_ack']");
        var $log = $form.find("textarea[name='log_msg']");
        var requiresLogMsg = $form.attr('data-tenure-requires-log-msg') === '1';

        var ackOk = $ack.is(':checked');
        var logOk = !requiresLogMsg || ($log.val() || '').trim() !== '';

        $ackErr.toggleClass('hidden', ackOk);
        $logErr.toggleClass('hidden', logOk);

        if (!ackOk) {
            $ack.trigger('focus');
            return false;
        }
        if (!logOk) {
            $log.trigger('focus');
            return false;
        }
        return true;
    }
    window.validateModDeleteGating = validateModDeleteGating;

    $(".reportForm, .asyncReportForm").each(function () {
        window.syncModSubmitState($(this));
    });

    $(document).on('change', "select[name='todo[0]']", function () {
        window.syncModSubmitState($(this).closest('form'));
    });

    $(document).on('change', "input[name='account_age_ack']", function () {
        window.syncModSubmitState($(this).closest('form'));
    });

    $(document).on('input change', "textarea[name='log_msg']", function () {
        window.syncModSubmitState($(this).closest('form'));
    });

    // Block the legacy (non-async) form post when the longtime-account gating
    // is not satisfied. The async path runs the same check before posting in
    // the .asyncReportForm submit handler below.
    $(document).on('submit', ".reportForm", function (e) {
        if (!validateModDeleteGating($(this))) {
            e.preventDefault();
        }
    });

    // Reveal the optional mod note only after the moderator commits to opting in.
    // Hides the field again when unticked so a leftover note can't ride along.
    // The note wrap sits as a sibling of the .banPhotosOptIn label inside the
    // .additionalActions wrapper, so scope the find to the enclosing form.
    $(document).on('change', "input[name='ban_photos_opt_in']", function () {
        var $form = $(this).closest('form');
        var $noteWrap = $form.find('.banPhotosOptInNoteWrap');
        if ($(this).is(':checked')) {
            $noteWrap.removeClass('hidden');
        } else {
            $noteWrap.addClass('hidden');
            $form.find("textarea[name='ban_photos_opt_in_note']").val('');
        }
    });

    // SUBMIT moderation action for a given report.
    // On success, hide the item. Otherwise, show an alert.
    // Delegated so forms injected dynamically by the moderateUserModal (which
    // writes HTML via innerHTML + Alpine.initTree) are still caught.
    $(document).on('submit', ".asyncReportForm", function (e) {
        e.preventDefault();
        var f = $(this);
        if (!validateModDeleteGating(f)) {
            return;
        }
        var ta = f.find("[name=log_msg]");
        if (ta.val().replace(/(\n|\r|\s)+$/, '') == "Comments...") {
            ta.val('');
        }
        ta.addClass("ajx_load");
        var repForm = $(this);

        // Photo-ban opt-in path. When the moderator picks Delete AND ticks the
        // "blacklist avatar" checkbox, the modal routes through the JWT
        // endpoint so `ban_photos_opt_in` lands on the mod_delete_queue row.
        // The legacy /app/mod/action surface stays the default for every
        // other action, so older callers (CLI, scripts) are unaffected.
        var $banPhotosCheckbox = f.find("input[name='ban_photos_opt_in']");
        var photoBanOptIn = $banPhotosCheckbox.length > 0 && $banPhotosCheckbox.is(':checked');
        var topVal = f.find("select[name='todo[0]']").first().val();
        var isDeleteAction = String(topVal) === String(MOD_ACTION_CAT_ID_DELETE);

        if (photoBanOptIn && isDeleteAction && window.ApiClient) {
            submitModDeleteViaApi(f, ta);
            return;
        }

        $.post("/app/mod/action?async=1", repForm.serialize(),
            function (data) {
                switch (data) {
                    case '0':
                        // Success: hide user reports
                        // Check if we're in a modal iframe
                        if (window.top !== window.self) {
                            // We're in an iframe/modal, reload the parent page
                            window.top.location.reload(true);
                        } else {
                            // Reset form so the log message doesn't bleed into the next report
                            // (browser autofill / repeated name="log_msg" fields can carry prior value)
                            f[0].reset();
                            ta.val('');
                            f.parents(".userReport").hide();
                            focusNextRep(repForm.parents("div.userReport"));
                        }
                        break;
                    case '1':
                        // Reload page
                        if (window.top !== window.self) {
                            window.top.location.reload(true);
                        } else {
                            window.location.reload(true);
                        }
                        break;
                    default:
                        alert(data);
                }
                ta.removeClass("ajx_load");
            });
    });

    // Clear a flagged profile
    $(".clearFlagged").click(function (e) {
        e.preventDefault();
        var ele = $(this);
        $.get($(this).parents("form").find("input[name='clear_url']").val(),
            function () {
                ele.parents("div.acctFlag").hide();
            }
        );
    });

    // Show jQuery-dependent form elements once DOM is loaded
    $(".modActions").show();
    $(".flaggedForm").show();

    // Jump to url based on the value of a select element
    $(".selNav").removeAttr("disabled").change(function () {
        window.location = $(this).val();
    });


    // Load pop-up windows
    $(function () { // Run this code when document is done loading
        $("a.popup").each(function (i) {
            $(this).click(function (event) {
                event.preventDefault();
                var params = $(this).data("popup") || {};
                if ($(this).attr("target")) {
                    params.windowName = $(this).attr("target");
                }
                var windowObject = UTIL.popup.open(this.href, params);
                $(this).data("windowObject", windowObject);
            });
        });
        $(".del_apprv_links").show();
    });

    // Load moderation warning templates (mod/warn.php)
    $('.mwt_link').click(function (e) {
        $('#subject').val($(this).attr('title'));
        $('#msg').val($('#' + $(this).attr('href')).html() + ($('#mwt_base').html()));
        e.preventDefault();
    });
    $('#modWarnTplLinks').show();


    // Dynamically populate select elements (delegated for AJAX-loaded content)
    $(document).on('change', 'select.mod_action', function () {
        // Picking a category by hand supersedes any preset still in flight, so
        // its responses cannot rewrite the chain back underneath the choice.
        // This pick owns the generation in turn, so its own response is dropped
        // if something supersedes it before landing.
        const isStale = window.claimModPresetGeneration($(this).closest('form'));

        $(this).attr("size", 1);

        // Clear all sub-selects & save next select ref
        let next_select = clearAllNextSelect($(this));

        // Display final warning checkbox if Warn is selected
        if ($(this).attr('name') == "todo[0]") {
            if ($(this).val() == 'warn') {
                $(this).nextAll('.fwarning').first().show();
            } else {
                $(this).nextAll('.fwarning').first().hide();
            }
        }

        // Reveal the device-ban opt-in only when the top-level action is
        // Delete (category id 2, see ModHelper::MOD_ACTION_CAT_ID_DELETE).
        if ($(this).attr('name') == "todo[0]") {
            window.syncModConditionalBlocks($(this).closest('form'));
        }

        // Get selected values for each select element, stopping at the first
        // empty one so we don't send placeholder levels the server will reject.
        let levels = [];
        $(this).parent().find("select.mod_action").each(function () {
            const v = $(this).val();
            if (v === null || v === '') {
                return false;
            }
            levels.push(v);
        });
        if (String($(this).val()) === MOD_ACTION_SUSPEND_TIMED) {
            next_select.hide();
        } else {
            modPopulateSelect(next_select, levels, undefined, isStale);
        }
        
        // After populating, check if this is the last select and auto-focus log message
        const $form = $(this).closest('form');
        const $currentSelect = $(this);
        
        setTimeout(function() {
            // Check if there are no more visible selects after this one
            const $allSelects = $form.find(".mod_actions_sel:visible");
            const isLastSelect = $currentSelect.is($allSelects.last());
            
            if (isLastSelect && $currentSelect.val() && String($currentSelect.val()) !== MOD_ACTION_SUSPEND_TIMED) {
                // Focus the log message textarea
                const $logMsg = $form.find("textarea[name='log_msg'], .logMsgTA").first();
                if ($logMsg.length > 0) {
                    $logMsg.focus();
                }
            }
        }, 200);
    });

    $(".logMsgTA").focus(function () {
        if ($(this).val().replace(/(\n|\r|\s)+$/, '') == "Comments...") {
            $(this).height("100px")
                .attr("color", "#000").val('');
        }
    });
    
    // Add Ctrl+Enter to submit the moderation form
    $(document).on('keydown', 'textarea[name="log_msg"], .logMsgTA', function(e) {
        if (e.ctrlKey && e.key === 'Enter') {
            e.preventDefault();
            $(this).closest('form').submit();
        }
    });

    // Alpine.js modal for moderating users
    // Create the modal container if it doesn't exist
    if (!document.getElementById('moderateUserModalContainer')) {
        const modalHtml = `
            <div id="moderateUserModalContainer"
                 x-data="moderateUserModal()"
                 x-show="open"
                 x-cloak
                 @keydown.escape.window="if (!window.__modMessagesModalOpen) close()"
                 @open-moderate-modal.window="openModal($event.detail.userId, $event.detail.preset, $event.detail.textFilterMatchId)"
                 class="fixed inset-0 z-[9999] overflow-hidden"
                 role="dialog"
                 aria-modal="true"
                 aria-labelledby="moderate-user-title">

                <!-- Backdrop -->
                <div x-show="open"
                     x-transition:enter="transition ease-out duration-200"
                     x-transition:enter-start="opacity-0"
                     x-transition:enter-end="opacity-100"
                     x-transition:leave="transition ease-in duration-150"
                     x-transition:leave-start="opacity-100"
                     x-transition:leave-end="opacity-0"
                     @click="close()"
                     class="fixed inset-0 bg-black/50"></div>

                <!-- Modal panel - full screen on mobile, centered dialog on sm+.
                     The outer positioning layer must NOT scroll on desktop, or the whole
                     modal will drift up/down instead of the inner columns scrolling. -->
                <div class="fixed inset-0 flex items-end sm:items-start justify-center sm:p-6 lg:p-8 overflow-hidden pointer-events-none">
                    <div x-show="open"
                         x-transition:enter="transition ease-out duration-200"
                         x-transition:enter-start="opacity-0 max-sm:translate-y-full sm:scale-95 sm:translate-y-4"
                         x-transition:enter-end="opacity-100 max-sm:translate-y-0 sm:scale-100 sm:translate-y-0"
                         x-transition:leave="transition ease-in duration-150"
                         x-transition:leave-start="opacity-100 max-sm:translate-y-0 sm:scale-100 sm:translate-y-0"
                         x-transition:leave-end="opacity-0 max-sm:translate-y-full sm:scale-95 sm:translate-y-4"
                         class="pointer-events-auto bg-white w-full max-sm:h-full max-sm:max-h-full sm:rounded-2xl shadow-2xl sm:max-w-5xl sm:h-[calc(100vh-4rem)] sm:max-h-[calc(100vh-4rem)] flex flex-col overflow-hidden">

                        <!-- Header -->
                        <div class="flex items-center justify-between px-4 py-3 border-b border-gray-100 flex-shrink-0" style="padding-top: max(0.75rem, env(safe-area-inset-top));">
                            <h2 id="moderate-user-title" class="text-lg font-semibold text-gray-900 flex items-center gap-2 min-w-0 truncate">
                                <svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>
                                </svg>
                                <span class="truncate">Moderate User</span>
                            </h2>
                            <button @click="close()"
                                    type="button"
                                    class="p-1.5 rounded-full hover:bg-gray-100 transition-colors"
                                    aria-label="Close">
                                <svg class="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                                </svg>
                            </button>
                        </div>

                        <!-- Content area -->
                        <div class="flex-1 min-h-0 overflow-y-auto lg:overflow-hidden p-4 lg:p-0 bg-gray-50 lg:bg-white max-sm:pb-[env(safe-area-inset-bottom)]">
                            <!-- Loading state -->
                            <template x-if="loading">
                                <div class="flex items-center justify-center py-12">
                                    <svg class="animate-spin h-8 w-8 text-sky-500" fill="none" viewBox="0 0 24 24">
                                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                </div>
                            </template>

                            <!-- Error state -->
                            <template x-if="error && !loading">
                                <div class="text-center py-12">
                                    <svg class="w-12 h-12 mx-auto text-red-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
                                    </svg>
                                    <p class="text-gray-600" x-text="error"></p>
                                    <button @click="retry()" class="mt-4 px-4 py-2 bg-sky-500 text-white rounded-lg hover:bg-sky-600 transition-colors">
                                        Retry
                                    </button>
                                </div>
                            </template>

                            <!-- Content (loaded via AJAX). We deliberately do NOT use
                                 x-html here: Alpine re-evaluates x-html whenever any
                                 reactive dep it reads changes, which wipes the DOM
                                 subtree — including any Alpine state nested in the
                                 injected HTML (tab selections, pager.loaded, etc.).
                                 Instead, we set innerHTML once from openModal() and
                                 call Alpine.initTree on it. -->
                            <div x-ref="contentHost" x-show="!loading && !error && content" x-cloak class="lg:h-full"></div>
                        </div>
                    </div>
                </div>
            </div>
        `;
        document.body.insertAdjacentHTML('beforeend', modalHtml);
    }

    // Copy-to-clipboard helper used by moderation UIs (email, UID, etc.).
    // Exposed globally so inline onclick="copyToClipboard(...)" attributes work
    // on any page that loads this bundle, including content injected via AJAX
    // into the moderate-user modal.
    window.showCopyFeedback = function (button) {
        if (!button) return;
        button.style.transform = 'scale(0.95)';
        setTimeout(function () { button.style.transform = ''; }, 150);
        var existing = button.querySelector('.copy-tooltip');
        if (existing) existing.remove();
        var tooltip = document.createElement('span');
        tooltip.className = 'copy-tooltip';
        tooltip.textContent = (typeof window.__copiedLabel === 'string') ? window.__copiedLabel : 'Copied';
        tooltip.style.cssText = 'position:absolute;top:-28px;left:50%;transform:translateX(-50%);background:#1f2937;color:#fff;font-size:11px;padding:2px 8px;border-radius:4px;white-space:nowrap;pointer-events:none;z-index:50;opacity:0;transition:opacity 0.15s;';
        button.style.position = 'relative';
        button.appendChild(tooltip);
        requestAnimationFrame(function () { tooltip.style.opacity = '1'; });
        setTimeout(function () {
            tooltip.style.opacity = '0';
            setTimeout(function () { tooltip.remove(); }, 150);
        }, 1500);
    };
    window.copyToClipboard = function (text, button) {
        if (!navigator.clipboard) {
            console.error('Clipboard API not available');
            return;
        }
        navigator.clipboard.writeText(text)
            .then(function () { window.showCopyFeedback(button); })
            .catch(function (err) { console.error('Failed to copy:', err); });
    };

    // Decode base64-encoded email spans. Moderator email addresses are
    // rendered as <span data-b64addr="..."> with empty text content; we
    // decode client-side so Cloudflare's server-side email-address scanner
    // has nothing to grab. The attribute name is intentionally not "email"
    // anywhere in the markup to avoid CF's "Email Address Obfuscation"
    // feature rewriting the node.
    function decodeOneSpan(el) {
        if (!el || !el.dataset || !el.dataset.b64addr) return;
        if (el.textContent) return;
        try { el.textContent = atob(el.dataset.b64addr); }
        catch (_e) { /* corrupt base64 — leave empty */ }
    }
    window.decodeB64Emails = function (root) {
        var container = root || document;
        container.querySelectorAll('[data-b64addr]').forEach(decodeOneSpan);
        // Defend against re-renders. Alpine's x-html can replace the subtree
        // (e.g. when a reactive dep nearby changes), which wipes the textContent
        // we just wrote onto the span. Watch the container and re-decode any
        // matching spans that appear, whether on first render or on a reset.
        if (container.__b64addrWatched) return;
        container.__b64addrWatched = true;
        var obs = new MutationObserver(function (mutations) {
            for (var i = 0; i < mutations.length; i++) {
                var m = mutations[i];
                for (var j = 0; j < m.addedNodes.length; j++) {
                    var node = m.addedNodes[j];
                    if (node.nodeType !== 1) continue;
                    if (node.matches && node.matches('[data-b64addr]')) decodeOneSpan(node);
                    if (node.querySelectorAll) {
                        node.querySelectorAll('[data-b64addr]').forEach(decodeOneSpan);
                    }
                }
            }
        });
        obs.observe(container, { childList: true, subtree: true });
    };

    // Alpine.js component for the moderate user modal
    // Alpine component for the retroactive ban / unban panel on the deleted-user
    // mod-details form. Routes through the JWT-protected /v1 endpoints rather
    // than the legacy /app/mod/action form-POST surface — see PR 3b.
    //
    // Inputs (`x-data` literal in the Twig):
    //   - userId, photoId, eligible, currentlyBanned
    //
    // The component owns its own modal so the panel can ban or unban without
    // depending on a global confirm dialog. Lucide icons are re-initialised on
    // open() because the modal subtree is hidden via x-show until the moderator
    // triggers it.
    window.modPhotoBanRetroPanel = function (opts) {
        return {
            userId: String(opts.userId || ''),
            photoId: String(opts.photoId || ''),
            eligible: opts.eligible === true,
            currentlyBanned: opts.currentlyBanned === true,
            modalOpen: false,
            mode: 'ban',
            submitting: false,
            error: '',
            status: '',
            openModal() {
                if (!this.eligible || this.currentlyBanned) return;
                this.mode = 'ban';
                this.error = '';
                this.modalOpen = true;
                this.$nextTick(() => {
                    if (this.$refs.noteField) this.$refs.noteField.value = '';
                    if (window.LucideIcons) window.LucideIcons.initialize(document.body);
                });
            },
            openUnbanModal() {
                if (!this.currentlyBanned) return;
                this.mode = 'unban';
                this.error = '';
                this.modalOpen = true;
                this.$nextTick(() => {
                    if (this.$refs.noteField) this.$refs.noteField.value = '';
                    if (window.LucideIcons) window.LucideIcons.initialize(document.body);
                });
            },
            closeModal() {
                this.modalOpen = false;
                this.error = '';
                this.submitting = false;
            },
            async submit(rawNote) {
                if (!window.ApiClient) {
                    this.error = 'ApiClient unavailable.';
                    return;
                }
                const note = (rawNote || '').trim();
                if (this.mode === 'unban' && note === '') {
                    this.error = 'Reason is required.';
                    return;
                }
                this.error = '';
                this.submitting = true;
                try {
                    const url = this.mode === 'ban'
                        ? '/mod/users/' + encodeURIComponent(this.userId) + '/ban-photo'
                        : '/mod/photo-bans/' + encodeURIComponent(this.photoId) + '/remove';
                    const payload = this.mode === 'ban'
                        ? (note === '' ? {} : { mod_note: note })
                        : { reason: note };
                    const res = await window.ApiClient.request(url, {
                        method: 'POST',
                        body: JSON.stringify(payload)
                    });
                    const envelope = res && typeof res.json === 'function'
                        ? { ok: res.ok, body: await res.json() }
                        : { ok: true, body: res };
                    if (!envelope.ok) {
                        this.error = (envelope.body && envelope.body.error)
                            ? envelope.body.error
                            : 'Request failed.';
                        return;
                    }
                    if (this.mode === 'ban') {
                        this.currentlyBanned = true;
                        this.status = (envelope.body && envelope.body.banned === false)
                            ? 'Already in ban list.'
                            : 'Avatar added to ban list.';
                    } else {
                        this.currentlyBanned = false;
                        this.status = (envelope.body && envelope.body.already_gone)
                            ? 'Was already removed.'
                            : 'Avatar removed from ban list.';
                    }
                    this.modalOpen = false;
                } catch (err) {
                    this.error = (err && err.message) ? err.message : 'Network error.';
                } finally {
                    this.submitting = false;
                }
            }
        };
    };

    window.moderateUserModal = function() {
        return {
            open: false,
            loading: false,
            error: null,
            content: '',
            userId: null,
            preset: null,
            textFilterMatchId: null,

            async openModal(userId, preset, textFilterMatchId) {
                this.userId = userId;
                this.preset = preset || null;
                this.textFilterMatchId = textFilterMatchId || null;
                this.open = true;
                this.loading = true;
                this.error = null;
                this.content = '';
                // Clear any previous content before fetching.
                if (this.$refs.contentHost) this.$refs.contentHost.innerHTML = '';

                // Lock body scroll
                window.scrollLock?.lock();

                try {
                    const response = await fetch(`/app/mod/user/ajax?user_id=${userId}`);
                    if (!response.ok) {
                        throw new Error('Failed to load user data');
                    }
                    const html = await response.text();
                    // Mark content truthy for the x-show guard; the actual DOM
                    // is written imperatively so Alpine can't re-render (wipe) it.
                    this.content = '1';
                    this.renderContent(html);
                    this.applyContextFields();
                } catch (err) {
                    this.error = err.message || 'An error occurred';
                } finally {
                    this.loading = false;
                    // Apply preset after DOM has the form mounted + b64 emails decoded.
                    if (this.preset && !this.error) {
                        const applyPreset = this.preset;
                        this.preset = null;
                        setTimeout(() => applyModPreset(this.$root ?? document, applyPreset), 100);
                    }
                }
            },

            renderContent(html) {
                const host = this.$refs.contentHost;
                if (!host) return;
                host.innerHTML = html;
                // Initialize Alpine on the newly-injected subtree so nested
                // x-data / @click / x-show directives inside the form work.
                if (window.Alpine && typeof window.Alpine.initTree === 'function') {
                    window.Alpine.initTree(host);
                }
                window.LucideIcons?.initialize(host);
                window.decodeB64Emails(host);
                if (window.jQuery) window.jQuery(document).trigger('csrf-forms');
            },

            applyContextFields() {
                if (!this.textFilterMatchId || !this.$refs.contentHost) return;
                const form = this.$refs.contentHost.querySelector('form[action*="/app/mod/action"]');
                if (!form || form.querySelector('input[name="text_filter_match_id"]')) return;

                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = 'text_filter_match_id';
                input.value = String(this.textFilterMatchId);
                form.appendChild(input);
            },

            retry() {
                if (this.userId) {
                    this.openModal(this.userId, this.preset, this.textFilterMatchId);
                }
            },

            close() {
                this.open = false;
                this.content = '';
                this.error = null;
                this.userId = null;
                this.textFilterMatchId = null;
                if (this.$refs.contentHost) this.$refs.contentHost.innerHTML = '';

                // Unlock body scroll
                window.scrollLock?.unlock();
            }
        };
    };

    // Alpine component — paginated "Load more" for moderation log entries.
    // Intentionally avoids IntersectionObserver / scroll-anchoring inside the
    // modal because the surrounding x-html subtree gets rebuilt on reactive
    // state changes, which fought with any scroll-based trigger.
    window.modUserLogPager = function (opts) {
        return {
            userId: String(opts.userId),
            loaded: Number(opts.initialLoaded) || 0,
            total: Number(opts.total) || 0,
            pageSize: 20,
            loading: false,
            exhausted: false,
            init() {
                if (this.loaded >= this.total) this.exhausted = true;
            },
            async loadMore() {
                if (this.loading || this.exhausted) return;
                this.loading = true;
                try {
                    const url = `/app/mod/user/log-items?user_id=${encodeURIComponent(this.userId)}&offset=${this.loaded}&limit=${this.pageSize}`;
                    const response = await fetch(url);
                    if (!response.ok) throw new Error('Failed to load log entries');
                    const html = (await response.text()).trim();
                    if (!html) { this.exhausted = true; return; }
                    const tmp = document.createElement('div');
                    tmp.innerHTML = html;
                    const added = tmp.children.length;
                    if (added === 0) { this.exhausted = true; return; }
                    this.$refs.entries.insertAdjacentHTML('beforeend', html);
                    window.LucideIcons?.initialize(this.$refs.entries);
                    this.loaded += added;
                    if (this.loaded >= this.total || added < this.pageSize) this.exhausted = true;
                } catch (err) {
                    console.warn('mod log pager:', err);
                } finally {
                    this.loading = false;
                }
            }
        };
    };

    // Alpine component — paginated "Load more" for the account-lifecycle
    // timeline. Mirrors modUserLogPager but hits a different endpoint: that
    // feed pages user_mod_log, this one pages the merged account_log /
    // account_freezes view. Additionally runs Alpine.initTree over the
    // appended rows, because a collapsed profile-edit entry carries its own
    // x-data expander that would otherwise never bind.
    window.modAccountTimelinePager = function (opts) {
        return {
            userId: String(opts.userId),
            // Injected from Twig via LinksHelper so the route has one source.
            endpoint: String(opts.endpoint || ''),
            loaded: Number(opts.initialLoaded) || 0,
            total: Number(opts.total) || 0,
            pageSize: 20,
            loading: false,
            exhausted: false,
            init() {
                if (this.loaded >= this.total) this.exhausted = true;
            },
            async loadMore() {
                if (this.loading || this.exhausted || !this.endpoint) return;
                this.loading = true;
                try {
                    const url = `${this.endpoint}?user_id=${encodeURIComponent(this.userId)}&offset=${this.loaded}&limit=${this.pageSize}`;
                    const response = await fetch(url);
                    if (!response.ok) throw new Error('Failed to load account timeline entries');
                    const html = (await response.text()).trim();
                    if (!html) { this.exhausted = true; return; }
                    const host = this.$refs.entries;
                    const before = host.childElementCount;
                    host.insertAdjacentHTML('beforeend', html);
                    const added = host.childElementCount - before;
                    if (added === 0) { this.exhausted = true; return; }
                    // Bind only the rows just appended — re-initialising the
                    // whole container would double-bind the existing ones.
                    for (let i = before; i < host.childElementCount; i++) {
                        window.Alpine?.initTree(host.children[i]);
                    }
                    window.LucideIcons?.initialize(host);
                    this.loaded += added;
                    if (this.loaded >= this.total || added < this.pageSize) this.exhausted = true;
                } catch (err) {
                    console.warn('account timeline pager:', err);
                } finally {
                    this.loading = false;
                }
            }
        };
    };

    // Alpine modal for moderator message browsing (replaces legacy iframe dialog)
    if (!document.getElementById('modMessagesModalContainer')) {
        const msgsModalHtml = `
            <div id="modMessagesModalContainer"
                 x-data="modMessagesModal()"
                 x-show="open"
                 x-cloak
                 @keydown.escape.window="close()"
                 @open-mod-messages-modal.window="openModal($event.detail.href)"
                 class="fixed inset-0 z-[9999] overflow-hidden"
                 role="dialog"
                 aria-modal="true"
                 aria-labelledby="mod-messages-title">

                <!-- Backdrop -->
                <div x-show="open"
                     x-transition:enter="transition ease-out duration-200"
                     x-transition:enter-start="opacity-0"
                     x-transition:enter-end="opacity-100"
                     x-transition:leave="transition ease-in duration-150"
                     x-transition:leave-start="opacity-100"
                     x-transition:leave-end="opacity-0"
                     @click="close()"
                     class="fixed inset-0 bg-black/50"></div>

                <!-- Panel - full screen on mobile, fixed-height on desktop -->
                <div class="fixed inset-0 flex items-end sm:items-center justify-center sm:p-6 overflow-hidden">
                    <div x-show="open"
                         x-transition:enter="transition ease-out duration-200"
                         x-transition:enter-start="opacity-0 max-sm:translate-y-full sm:scale-95"
                         x-transition:enter-end="opacity-100 max-sm:translate-y-0 sm:scale-100"
                         x-transition:leave="transition ease-in duration-150"
                         x-transition:leave-start="opacity-100 max-sm:translate-y-0 sm:scale-100"
                         x-transition:leave-end="opacity-0 max-sm:translate-y-full sm:scale-95"
                         @click.stop
                         class="bg-white w-full max-sm:h-full max-sm:max-h-full sm:rounded-2xl shadow-2xl sm:max-w-6xl sm:w-[92vw] sm:h-[82vh] sm:max-h-[calc(100vh-3rem)] flex flex-col overflow-hidden">

                        <!-- Header -->
                        <div class="flex items-center justify-between px-4 py-3 border-b border-gray-100 flex-shrink-0" style="padding-top: max(0.75rem, env(safe-area-inset-top));">
                            <h2 id="mod-messages-title" class="text-lg font-semibold text-gray-900">Messages</h2>
                            <button @click="close()"
                                    type="button"
                                    class="p-1.5 rounded-full hover:bg-gray-100 transition-colors"
                                    aria-label="Close">
                                <svg class="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                                </svg>
                            </button>
                        </div>

                        <!-- Content -->
                        <div class="flex-1 min-h-0 overflow-y-auto p-4 bg-white max-sm:pb-[env(safe-area-inset-bottom)]" x-ref="contentHost" @click="handleContentClick($event)">
                            <template x-if="loading">
                                <div class="flex items-center justify-center py-12">
                                    <svg class="animate-spin h-8 w-8 text-sky-500" fill="none" viewBox="0 0 24 24">
                                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                </div>
                            </template>
                            <template x-if="error && !loading">
                                <div class="text-center py-12 text-sm text-red-600" x-text="error"></div>
                            </template>
                            <!-- Content (loaded via AJAX). We deliberately do NOT use
                                 x-html here: Alpine re-evaluates x-html whenever any
                                 reactive dep it reads changes, which wipes the DOM
                                 subtree — including hydrated audio players, lucide
                                 icons, and any nested Alpine state. We assign innerHTML
                                 once from load() and call Alpine.initTree on it. -->
                            <div x-ref="content" x-show="!loading && !error && content" x-cloak></div>
                        </div>
                    </div>
                </div>
            </div>
        `;
        document.body.insertAdjacentHTML('beforeend', msgsModalHtml);
    }

    // Map a public /app/mod/messages/<threads|history|outgoing> href to
    // its ajax fragment endpoint by appending /ajax to the pathname
    // (query preserved). Returns null for any other URL or if the href
    // cannot be parsed, which also serves as the "this link is not
    // in-modal navigable" signal to the click handler.
    function toModMessagesAjaxUrl(href) {
        try {
            const u = new URL(href, window.location.origin);
            const m = u.pathname.match(/^\/app\/mod\/messages\/(threads|history|outgoing)$/);
            if (!m) return null;
            u.pathname = '/app/mod/messages/' + m[1] + '/ajax';
            return u.pathname + (u.search || '');
        } catch (_) {
            return null;
        }
    }

    window.modMessagesModal = function () {
        return {
            open: false,
            loading: false,
            error: null,
            content: '',

            async openModal(href) {
                this.open = true;
                // Signal to outer modals (moderateUserModal) that an inner
                // modal is on top, so a single Esc keypress closes only
                // the inner one rather than cascading through stacked
                // window-level handlers.
                window.__modMessagesModalOpen = true;
                window.scrollLock?.lock();
                await this.load(href);
            },

            async load(href) {
                const ajaxUrl = toModMessagesAjaxUrl(href);
                if (!ajaxUrl) {
                    this.error = 'Invalid moderator messages URL';
                    this.loading = false;
                    return;
                }
                this.loading = true;
                this.error = null;
                this.content = '';
                if (this.$refs.content) this.$refs.content.innerHTML = '';
                try {
                    const res = await fetch(ajaxUrl, { credentials: 'same-origin' });
                    // 4xx responses carry a translated server-rendered error
                    // fragment in the body, so render as content. 5xx / network
                    // errors fall through to the error state.
                    if (!res.ok && res.status >= 500) {
                        throw new Error('HTTP ' + res.status);
                    }
                    const html = await res.text();
                    // Truthy marker for the x-show guard; the actual DOM is
                    // written imperatively below so Alpine can't wipe it on
                    // a reactive re-render (which would destroy hydrated
                    // audio players, lucide icons, etc.).
                    this.content = '1';
                    this.$nextTick(() => {
                        const host = this.$refs.content;
                        if (host) {
                            host.innerHTML = html;
                            if (window.Alpine && typeof window.Alpine.initTree === 'function') {
                                window.Alpine.initTree(host);
                            }
                            window.LucideIcons?.initialize(host);
                            // Hydrate the custom audio player on any voice
                            // messages in the injected fragment — the
                            // global auto-init only watches the regular PM
                            // viewer's #threads_right container.
                            window.initAudioPlayers?.(host);
                        }
                        if (this.$refs.contentHost) {
                            this.$refs.contentHost.scrollTop = 0;
                        }
                    });
                } catch (err) {
                    this.error = err && err.message ? err.message : 'Failed to load';
                } finally {
                    this.loading = false;
                }
            },

            handleContentClick(e) {
                if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return; // honour new-tab intents
                if (e.target.closest('.audio-player')) return;

                // Row-level clickable thread rows: route via data-href unless
                // the click originated on an inner anchor (contact profile link,
                // the View link itself — those take precedence via the normal
                // anchor handling below).
                const row = e.target.closest('.mod-msgs-row-link');
                const innerLink = e.target.closest('a');
                if (row && !innerLink) {
                    const rowHref = row.getAttribute('data-href');
                    if (rowHref && toModMessagesAjaxUrl(rowHref)) {
                        e.preventDefault();
                        this.load(rowHref);
                        return;
                    }
                }

                // Intercept in-modal navigation (View, Back, pagination) and refetch
                // into the same modal instead of letting the browser navigate.
                if (!innerLink) return;
                if (innerLink.target && innerLink.target !== '_self' && innerLink.target !== '') return; // skip _blank etc
                const href = innerLink.getAttribute('href');
                if (!href) return;
                if (!toModMessagesAjaxUrl(href)) return;
                e.preventDefault();
                this.load(href);
            },

            close() {
                this.open = false;
                this.content = '';
                this.error = null;
                if (this.$refs.content) this.$refs.content.innerHTML = '';
                window.__modMessagesModalOpen = false;
                window.scrollLock?.unlock();
            }
        };
    };

    // Keep legacy jQuery UI dialog for photo moderation — unchanged for now
    $("body").append('<div id="modPhotoDialog" title="Moderate Photo"></div>');
    $("#modPhotoDialog").dialog({
        autoOpen: false,
        width: 300,
        height: 200,
    });

    // Bind to mod link - dispatch Alpine.js event
    $(document).on('click', '.profModLink', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
        e.preventDefault();
        var userId = $(this).attr('user-id');

        // Dispatch custom event to open the Alpine.js modal
        window.dispatchEvent(new CustomEvent('open-moderate-modal', {
            detail: { userId: userId }
        }));
    });

    // Open moderator messages in the Alpine modal (replaces legacy iframe dialog)
    $(document).on('click', '.modMsgsLink', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
        e.preventDefault();
        window.dispatchEvent(new CustomEvent('open-mod-messages-modal', {
            detail: { href: $(this).attr('href') }
        }));
    });

    // Make moderator thread rows clickable: route navigation the same way the
    // "View" link does — in-modal refetch when inside the modal container,
    // normal navigation on the standalone page. The inner anchor wrapping the
    // avatar/name cell keeps linking to the contact profile (target=_blank),
    // so only skip row routing when the click landed on one of those inner
    // anchors; everywhere else in the row triggers thread navigation.
    $(document).on('click', '.mod-msgs-row-link', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
        const innerAnchor = e.target.closest('a');
        if (innerAnchor && !innerAnchor.classList.contains('mod-msgs-nav')) return;
        const href = this.getAttribute('data-href');
        if (!href) return;
        e.preventDefault();
        const insideModal = !!this.closest('#modMessagesModalContainer');
        if (insideModal) {
            window.dispatchEvent(new CustomEvent('open-mod-messages-modal', { detail: { href: href } }));
        } else {
            window.location.assign(href);
        }
    });

    $(document).on('keydown', '.mod-msgs-row-link', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        const href = this.getAttribute('data-href');
        if (!href) return;
        e.preventDefault();
        const insideModal = !!this.closest('#modMessagesModalContainer');
        if (insideModal) {
            window.dispatchEvent(new CustomEvent('open-mod-messages-modal', { detail: { href: href } }));
        } else {
            window.location.assign(href);
        }
    });

    // Bind to user photo moderation link
    $('.mod_photo').click(function (e) {
        $("#modPhotoDialog").html('<iframe id="modIframePhoto" width="100%" ' +
            'height="100%" marginWidth="0" marginHeight="0" frameBorder="0" ' +
            'scrolling="auto" />')
            .dialog("open");
        $("#modIframePhoto").attr("src", $(this).attr('href'));
        e.preventDefault();
    });

    /*
    // Photo moderation dialog
    $(".mod_photo").click(function (e) {
        let dialog_id = $(this).data("targetid");
        const photo_dialog = $("#" + dialog_id);
        photo_dialog.dialog({
            autoOpen: false,
            width: 300,
            height: 200,
            title: "Moderate Photo",
            buttons: {
                "Submit": function () {
                    $.post("/app/mod/action?async=1",
                        $("#" + dialog_id + "_form").serialize(),
                        function (data) {
                            if (data != '0') {
                                alert("Error: " + data);
                            } else {
                                window.location.reload(true);
                            }
                        });
                    $(this).dialog("close");
                },
                "Cancel": function () {
                    $(this).dialog("close");
                }
            },
        });
        photo_dialog.dialog("open");
        e.preventDefault();
    });
     */
});

// Alpine component factory for the mod-issued Suspend block in the
// moderate-user modal (_suspend-form.twig). Defined at top level — not
// inline inside the partial — because the partial is loaded via
// Alpine.initTree on an innerHTML-injected subtree, which does not
// execute inline <script> tags. The factory must already be in window
// scope when initTree binds the x-data attribute.
window.modSuspendUserBlock = window.modSuspendUserBlock || function (userId, redirect, messages) {
    messages = messages || {};
    return {
        // userId is always a string — IDs in InterPals exceed
        // Number.MAX_SAFE_INTEGER and corrupt silently if parsed as a
        // Number, so the Twig caller passes the value quoted and we
        // never re-coerce.
        userId: String(userId),
        redirect: redirect || '',
        durationDays: 7,
        reason: '',
        logMsg: '',
        submitting: false,
        error: '',
        get canSubmit() {
            return Number.isFinite(this.durationDays)
                && this.durationDays >= 1
                && this.durationDays <= 365
                && this.reason !== '';
        },
        submit: async function () {
            if (!this.canSubmit || this.submitting) return;
            this.submitting = true;
            this.error = '';
            try {
                // Server-side apiRequestValidator reads SOURCE_POST from the
                // Symfony form-bag, which only populates from
                // application/x-www-form-urlencoded bodies. JSON would
                // arrive intact in php://input but $request->request->all()
                // would come back empty and validation would fail with
                // "field required". Match mod-appeals.js's
                // postFormUrlEncoded pattern.
                const body = new URLSearchParams();
                body.append('duration_days', String(this.durationDays));
                body.append('reason', this.reason);
                if (this.logMsg) {
                    body.append('log_msg', this.logMsg);
                }

                const res = await window.ApiClient.request(
                    '/mod/users/' + encodeURIComponent(this.userId) + '/suspend',
                    {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        body: body.toString(),
                    }
                );

                if (res && typeof res === 'object' && typeof res.ok === 'boolean' && !res.ok) {
                    // ApiClient returns the raw Response on a non-2xx
                    // status. Parse the error envelope per API contract.
                    let message = (messages.failedStatus || '').replace('%status%', res.status) || String(res.status);
                    try {
                        const parsed = await res.json();
                        if (parsed && parsed.error) {
                            message = typeof parsed.error === 'string'
                                ? parsed.error
                                : (parsed.error.message || message);
                        }
                    } catch (_parseErr) {
                        // Non-JSON body — fall back to status-code message.
                    }
                    this.error = message;
                    this.submitting = false;
                    return;
                }

                if (this.redirect) {
                    window.location.assign(this.redirect);
                } else {
                    window.location.reload();
                }
            } catch (e) {
                this.error = (e && e.message) ? e.message : (messages.failed || '');
                this.submitting = false;
            }
        },
    };
};

window.modUnsuspendUserBlock = window.modUnsuspendUserBlock || function (userId, redirect, defaultReason, messages) {
    messages = messages || {};
    return {
        userId: String(userId),
        redirect: redirect || '',
        expanded: false,
        reason: defaultReason || '',
        logMsg: '',
        submitting: false,
        error: '',
        get canSubmit() {
            return this.reason !== '';
        },
        submit: async function () {
            if (!this.canSubmit || this.submitting) return;
            this.submitting = true;
            this.error = '';
            try {
                const body = new URLSearchParams();
                body.append('reason', this.reason);
                if (this.logMsg) {
                    body.append('log_msg', this.logMsg);
                }

                const res = await window.ApiClient.request(
                    '/mod/users/' + encodeURIComponent(this.userId) + '/unsuspend',
                    {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        body: body.toString(),
                    }
                );

                if (res && typeof res === 'object' && typeof res.ok === 'boolean' && !res.ok) {
                    let message = (messages.failedStatus || '').replace('%status%', res.status) || String(res.status);
                    try {
                        const parsed = await res.json();
                        if (parsed && parsed.error) {
                            message = typeof parsed.error === 'string'
                                ? parsed.error
                                : (parsed.error.message || message);
                        }
                    } catch (_parseErr) {
                        // Non-JSON body, so keep the status-code message.
                    }
                    this.error = message;
                    this.submitting = false;
                    return;
                }

                if (this.redirect) {
                    window.location.assign(this.redirect);
                } else {
                    window.location.reload();
                }
            } catch (e) {
                this.error = (e && e.message) ? e.message : (messages.failed || '');
                this.submitting = false;
            }
        },
    };
};
